/**
 * PayTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const PayTab = ({ ctx }) => {
  const {
    formData,
    handlePayChange,
  } = ctx;

  return (
          <TabsContent value="pay">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <CreditCard className="w-5 h-5 text-stone-700" />
                  Basic Pay (Infotype 0008)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Pay Scale Type</Label>
                    <Input
                      value={formData.basic_pay.pay_scale_type}
                      onChange={(e) => handlePayChange('pay_scale_type', e.target.value)}
                      placeholder="01"
                    />
                  </div>
                  <div>
                    <Label>Pay Scale Area</Label>
                    <Input
                      value={formData.basic_pay.pay_scale_area}
                      onChange={(e) => handlePayChange('pay_scale_area', e.target.value)}
                      placeholder="01"
                    />
                  </div>
                  <div>
                    <Label>Pay Scale Group/Grade</Label>
                    <Input
                      value={formData.basic_pay.pay_scale_group}
                      onChange={(e) => handlePayChange('pay_scale_group', e.target.value)}
                      placeholder="E1"
                    />
                  </div>
                  <div>
                    <Label>Pay Scale Level/Step</Label>
                    <Input
                      value={formData.basic_pay.pay_scale_level}
                      onChange={(e) => handlePayChange('pay_scale_level', e.target.value)}
                      placeholder="1"
                    />
                  </div>
                  <div>
                    <Label>Basic Salary</Label>
                    <Input
                      type="number"
                      value={formData.basic_pay.basic_salary}
                      onChange={(e) => handlePayChange('basic_salary', e.target.value ? parseFloat(e.target.value) : '')}
                      placeholder="50000"
                    />
                  </div>
                  <div>
                    <Label>Currency</Label>
                    <select
                      value={formData.basic_pay.currency}
                      onChange={(e) => handlePayChange('currency', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="INR">INR</option>
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                    </select>
                  </div>
                  <div>
                    <Label>Pay Frequency</Label>
                    <select
                      value={formData.basic_pay.pay_frequency}
                      onChange={(e) => handlePayChange('pay_frequency', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="MONTHLY">Monthly</option>
                      <option value="WEEKLY">Weekly</option>
                      <option value="BIWEEKLY">Bi-Weekly</option>
                      <option value="ANNUAL">Annual</option>
                    </select>
                  </div>
                  <div>
                    <Label>Annual Salary</Label>
                    <Input
                      type="number"
                      value={formData.basic_pay.annual_salary}
                      onChange={(e) => handlePayChange('annual_salary', e.target.value ? parseFloat(e.target.value) : '')}
                      placeholder="600000"
                    />
                  </div>
                  <div>
                    <Label>Hourly Rate</Label>
                    <Input
                      type="number"
                      value={formData.basic_pay.hourly_rate}
                      onChange={(e) => handlePayChange('hourly_rate', e.target.value ? parseFloat(e.target.value) : '')}
                      placeholder="250"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default PayTab;
